<template>
    <div>
        <b-carousel id="carousel1"
                    style="text-shadow: 1px 1px 2px #333;"
                    controls
                    indicators
                    background="#ababab"
                    :interval="2500"
                    img-width="1024"
                    img-height="480"
                    v-model="slide"
                    @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd"
                    class="carousel-fade rounded">
            <span v-for="image in images">
              <!-- Slides with image only -->
              <div v-if="image.file">
                <a :href="image.file" target="_blank" class="show d-block">
                  <b-carousel-slide class="rounded">
                   <img slot="img"
                       class="d-block img-fluid w-100 rounded"
                       width="1024"
                       height="480"
                       :src="image.image"
                      >   
                </b-carousel-slide>
              </a>
            </div>
            <div v-else>
              <b-carousel-slide class="rounded">
               <img slot="img"
                   class="d-block img-fluid w-100 rounded"
                   width="1024"
                   height="480"
                   :src="image"
                  >   
                </b-carousel-slide>
              </div>
            </span>
        </b-carousel>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data () {
        return {
            slide: 0,
            sliding: null,
    }
  },
    props: {
        images: Array,
    }, 
    methods: {
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/SharedComponents/ImageCarousel.vue